<template>
  <div class="testimonial">
    <v-container style="margin-top: 10px">
      <h3><span>Testimonials</span></h3>
      <v-layout justify-center>
        <v-btn class="button" elevation="5" @click="newTestimonial" rounded>Add Testimonial</v-btn>
      </v-layout>

      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Add Testimonial</span>
            </v-card-title>
            <v-col cols="12" md="12">
              <v-text-field label="Name" v-model="testimonial.name" :error-messages="nameError" required
                @input="$v.testimonial.name.$touch()" @blur="$v.testimonial.name.$touch()"></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea auto-grow counter label="Description" v-model="testimonial.description"
                :error-messages="descriptionError" :rules="rules" required @input="$v.testimonial.description.$touch()"
                @blur="$v.testimonial.description.$touch()"></v-textarea>
            </v-col>
            <v-col cols="12" sm="12">
              <v-file-input chips counter show-size truncate-length="24" v-model="images" required
                label="Select Image File..." accept="image/*" @change="uploadImage"></v-file-input>
              <div class="img">
                <img class="demo" :src="imgurl" alt="" />
              </div>
            </v-col>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click.prevent="addTestimonial">
                Add
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-simple-table style="margin-top: 4%">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left"> Name</th>
              <th class="text-left">Image</th>

              <th class="text-left">Delete</th>
            </tr>
          </thead>
          <tbody :key="index" v-for="(testimonial, index) in Testimonials">
            <tr>
              <td>{{ testimonial.name }}</td>
              <td>
                <v-avatar>
                  <img width="300px" :src="testimonial.images" alt="John" />
                </v-avatar>
              </td>
              <td>
                <v-btn icon @click="deleteTestimonial(testimonial)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>

    <v-snackbar top v-model="snackbar">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
//eslint-disable-next-line
import { fb, db } from "../firebase.js";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  name: "add-testimonials",
  mixins: [validationMixin],
  validations: {
    testimonial: {
      name: { required },
      description: { required, minLength: minLength(130), maxLength: maxLength(150) }
    }
  },
  data() {
    return {
      rules: [v => v.length <= 150 && v.length >= 130 || 'Minimum 130 - Maximum 150 characters'],
      snackbar: false,
      text: "",
      dialog: false,
      imgurl: null,
      images: null,
      Testimonials: [],
      testimonial: {
        name: null,
        images: null
      }
    };
  },
  firestore() {
    return {
      Testimonials: db.collection("Testimonials")
    };
  },
  methods: {
    newTestimonial() {
      console.log(this.Testimonials.length);
      if (this.Testimonials.length < 6) {
        this.reset();
        console.log("hi")
        this.dialog = !this.dialog;
      }else {
        this.snackbar = true;
        this.text = "You can't add more than 6 testimonials";
      }
    },
    reset() {
      this.testimonial.name = null;
      this.testimonial.description = null;
      this.testimonial.images = null;
      this.images = null;
      this.imgurl = null;
    },
    addTestimonial() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // console.log(this.testimonial.images.name)
        var storageRef = fb.storage().ref("Testimonials/" + this.images.name);
        let uploadTask = storageRef.put(this.images);
        uploadTask.on(
          "state_changed",
          snapshot => {
            console.log(snapshot);
          },
          error => {
            console.log(error);
            // Handle unsuccessful uploads
          },
          () => {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.testimonial.images = downloadURL;
              console.log("File available at", downloadURL);
              db.collection("Testimonials")
                .add(this.testimonial)
                .catch(function (error) {
                  console.error("Error adding document: ", error);
                });
            });
          }
        );

        //logic
        this.dialog = false;
        this.text = "Testimonials added";
        this.snackbar = true;
      } else {
        console.log("not");
      }
    },

    deleteTestimonial(doc) {
      let image = fb.storage().refFromURL(doc.images);
      console.log(image);
      image
        .delete()
        .then(function () {
          console.log("image deleted");
        })
        .catch(function (error) {
          // Uh-oh, an error occurred!err
          console.log(error);
          console.log("an error occurred");
        });

      this.$firestore.Testimonials.doc(doc[".key"])
        .delete()
        .then(() => {
          console.log("Document successfully deleted!");
          this.text = "Testimonial successfully deleted!";
          this.snackbar = true;
        })
        .catch(error => {
          console.error("Error removing document: ", error);
          this.text = "Error Removing Testimonial";
          this.snackbar = true;
        });
      console.log(doc['.key'])
    },
    uploadImage() {
      // let file = e.target.files[0];
      if (this.images === null) {
        this.imgurl = null;
        this.testimonial.images = null;
      }
      this.imgurl = URL.createObjectURL(this.images);
      console.log(this.imgurl);
    }
  },
  computed: {
    nameError() {
      const errors = [];
      if (!this.$v.testimonial.name.$dirty) return errors;
      !this.$v.testimonial.name.required && errors.push("Name is required.");
      return errors;
    },
    descriptionError() {
      const errors = [];
      if (!this.$v.testimonial.description.$dirty) return errors;
      !this.$v.testimonial.description.required &&
        errors.push("Description is required.");
      return errors;
    }

  },
  watch: {
    // testimonial: {
    //   //eslint-disable-next-line
    //   handler(val, oldVal) {
    //     if (this.images === null) {
    //       console.log("dsa nul")
    //       // this.imgurl = "";
    //       // this.testimonial.images = "";
    //     }
    //   },
    //   deep: true,
    // },
  }
};
</script>

<style>
span.delete-img {
  position: absolute;
}

i {
  color: #040674;
}

span.delete-img:hover {
  cursor: pointer;
  color: #f5a623;
}

.demo {
  width: auto;
  height: 200px;
}

@media only screen and (max-width: 450px) {
  .demo {
    height: 100px;
  }
}
</style>
